// src/components/generics/ScratchProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";

import { useScratchFeature } from "../../contexts/ScratchFeatureContext";
import ProtectedRoute from "./ProtectedRoute";

/**
 * Gates `/scratch*` routes on the site-wide `scratchEnabled` flag before
 * falling through to the normal login check — when the flag is off the
 * feature must be unreachable even by typing the URL directly, for both
 * anonymous visitors and logged-in users.
 */
export default function ScratchProtectedRoute({ element }) {
  const { scratchEnabled, loading } = useScratchFeature();

  if (loading) return null;
  if (!scratchEnabled) return <Navigate to="/" replace />;

  return <ProtectedRoute element={element} />;
}
